import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import unitStore from "@/features/risks/entities/unit/model/unit.store"
import jobStore from "@/features/risks/entities/job/model/job.store"
import Chip from "@/components/chip"
import { t } from "i18next"

interface Props {
  className?: string
  deletable?: boolean
}

export default function JobsChips({ className = "", deletable = true }: Props) {
  const dispatch = useAppDispatch()

  const draft = useAppSelector(unitStore.selectors.draft)
  const jobs = useAppSelector(jobStore.selectors.list)

  const handleDelete = (id: string) => {
    dispatch(
      unitStore.actions.edit({
        key: "JobIds",
        value: draft.JobIds.filter((x) => x !== id)
      })
    )
  }

  return (
    <div className={`flex flex-wrap gap-3 items-center ${className}`}>
      {draft.JobIds.length === 0 ? (
        <div className="text-gray-400 text-sm italic">
          {t("Vous n'avez pas sélectionné de métier pour l'unité de travail.")}
        </div>
      ) : (
        <div className="flex flex-wrap gap-3 items-center">
          {draft.JobIds.map((id) => {
            const j = jobs.find((x) => x.id === id)
            if (!j) return null

            return (
              <Chip
                key={id}
                className="whitespace-normal px-3 py-1 text-center"
                onDelete={deletable ? () => handleDelete(id) : undefined}>
                {j.jobName}
              </Chip>
            )
          })}
        </div>
      )}
    </div>
  )
}
